import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import { compose } from '../../../../services/utilityFunctions';
import SessionProp from '../../propTypes/sessionProp';
import { checkIfUserIsInParticipantsList } from '../../propTypes/sessionUtils';
import LoggedUserContext from '../../../../contextProviders/LoggedUserContext';

const SessionDocuments = ({ t, session }) => {
  /** Context */
  const { loggedUser } = useContext(LoggedUserContext);
  const loggedUserId = loggedUser?._id || null;

  /** PROPS */
  const { documentsAvailableOnlyInTheEnd, isDocumentsAvailable, documents, startDate, endDate } = session;

  const hasDocuments = documents?.length > 0;
  const hasAlreadyStarted = new Date().valueOf() >= new Date(startDate).valueOf();
  const hasAlreadyEnded = new Date().valueOf() >= new Date(endDate).valueOf();

  let noDocumentsInfo = t('session.detail.no.documents');

  if (
    hasDocuments &&
    !documentsAvailableOnlyInTheEnd &&
    !hasAlreadyStarted &&
    checkIfUserIsInParticipantsList(session, loggedUserId)
  ) {
    noDocumentsInfo = t('session.detail.no.documentsUntilSessionStarted');
  }

  if (
    hasDocuments &&
    documentsAvailableOnlyInTheEnd &&
    !hasAlreadyEnded &&
    checkIfUserIsInParticipantsList(session, loggedUserId)
  ) {
    noDocumentsInfo = t('session.detail.no.documentsUntilSessionEnded');
  }

  return (
    <>
      {isDocumentsAvailable ? (
        <div className="session-location">
          <span className="session-documents-holder row">
            {Object.keys(documents).map(item => (
              <div className="col-lg-4 col-6 session-pdf">
                <div className="user-holder">
                  <div className="user-img">
                    <div className="user-check">
                      <a
                        href={documents[item].file.url}
                        target="_blank"
                        style={{ textDecoration: 'none' }}
                        rel="noopener noreferrer"
                      >
                        <i id="icon" className="la la-download" />
                      </a>
                    </div>
                    <div className="user-pic">
                      <img
                        src="/images/academy/session/pdf-session.svg"
                        alt="Pdf"
                      />
                    </div>
                  </div>
                  <p className="user-name">{documents[item].file.originalName}</p>
                </div>
              </div>
            ))}
          </span>
        </div>
      ) : (
        <div className="session-no-docs">
          <h4 className="no-data-hint">
            {noDocumentsInfo}
          </h4>
        </div>
      )}
    </>
  );
};

SessionDocuments.propTypes = {
  t: PropTypes.func.isRequired,
  session: PropTypes.shape(SessionProp.propType).isRequired,
};
SessionDocuments.defaultProps = {};

export default compose(translate)(SessionDocuments);
